(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2683],{

/***/ 98523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18132);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26718);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71033);
/* harmony import */ var src_containers_data_cities_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82606);
/* harmony import */ var src_utils_dateUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73119);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);











const LandingPageHeaderContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(3382), __webpack_require__.e(7405)]).then(__webpack_require__.bind(__webpack_require__, 27405)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(27405)]
  }
});
const LandingBrandNltOffersContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(3382), __webpack_require__.e(5675), __webpack_require__.e(9135), __webpack_require__.e(1113), __webpack_require__.e(2732), __webpack_require__.e(6917), __webpack_require__.e(2702), __webpack_require__.e(7118)]).then(__webpack_require__.bind(__webpack_require__, 98681)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(98681)]
  }
});
const HomeNltOffersContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 8221).then(__webpack_require__.bind(__webpack_require__, 28221)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(28221)]
  }
});
const InfoBoxContainer2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 8947).then(__webpack_require__.bind(__webpack_require__, 58947)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(58947)]
  }
});
const {
  formattedMonth,
  formattedYear
} = (0,src_utils_dateUtils__WEBPACK_IMPORTED_MODULE_4__/* .getFormattedMonthYear */ .P)();

const isSlugCity = slug => src_containers_data_cities_json__WEBPACK_IMPORTED_MODULE_5__.find(city => city.href.toLowerCase() === `/noleggio-a-lungo-termine/${slug.toLowerCase()}`) !== undefined;

const NltLandingPage = _ref => {
  let {
    slug,
    contents,
    page
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)();
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  const isCity = isSlugCity(slug);
  const isBrand = !isCity;
  const formattedIncipit = (0,src_utils_dateUtils__WEBPACK_IMPORTED_MODULE_4__/* .replaceDatePlaceholders */ .h)(contents.incipit);
  const formattedMetaDataTitle = (0,src_utils_dateUtils__WEBPACK_IMPORTED_MODULE_4__/* .replaceDatePlaceholders */ .h)(contents.metaTitle);
  const formattedMetaDataDescription = (0,src_utils_dateUtils__WEBPACK_IMPORTED_MODULE_4__/* .replaceDatePlaceholders */ .h)(contents.metaDescription);
  const pageTitle = isCity ? `Noleggio a Lungo Termine a ${contents.name}: Scopri le Migliori Offerte di ${formattedMonth} ${formattedYear}` : `Noleggio a Lungo Termine ${contents.name}: Scopri le Migliori Offerte di ${formattedMonth} ${formattedYear}`;
  const crumbs = [{
    page: 'Home Page',
    href: '/',
    title: 'Home Page'
  }, {
    page: 'Offerte Noleggio a Lungo Termine',
    href: '/noleggio-a-lungo-termine',
    title: 'Offerte Noleggio a Lungo Termine'
  }, {
    page: pageTitle,
    href: router.asPath,
    title: pageTitle
  }];
  let contentText;

  if (Array.isArray(contents.text)) {
    contentText = contents.text.join('');
  } else {
    contentText = contents.text;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
    bgColor: "baseNeutral.100",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      title: formattedMetaDataTitle || `${t('nltPage:header.title')} ${contents.name}`
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_9__/* .LinkRel */ .M, {
      rel: "canonical",
      href: `https://www.carplanner.com/noleggio-a-lungo-termine/${slug}`
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(LandingPageHeaderContainer, {
      title: pageTitle,
      incipit: formattedIncipit,
      crumbs: crumbs,
      image: contents === null || contents === void 0 ? void 0 : contents.image,
      bgColor: isCity ? `baseWhite` : `baseNeutral.100`,
      isCity: isCity,
      action: isCity ? t('nltPage:landingCity.action') : null,
      actionTitle: isCity ? t('nltPage:landingCity.actionTitle', {
        slug: contents.name
      }) : null,
      target: "offerte-noleggio"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
      w: "100%",
      maxW: "100%",
      display: "inline-block",
      children: isBrand ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          meta: t(`nltPage:landingBrand.meta`, {
            returnObjects: true,
            brand: contents.name,
            metaDataDescription: formattedMetaDataDescription
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(LandingBrandNltOffersContainer, {
          slug: slug,
          page: page
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          meta: t(`nltPage:landingCity.meta`, {
            returnObjects: true,
            city: contents.name,
            metaDataDescription: formattedMetaDataDescription
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
          mb: "xxl6",
          px: "l",
          maxW: "8xl",
          mx: "auto",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HomeNltOffersContainer, {
            numPerView: 4,
            title: t('nltPage:landingCity.title', {
              city: contents.name
            }),
            action: t('indexPage:nlt_offers.action'),
            alt: t('indexPage:nlt_offers.alt'),
            bgColor: "baseNeutral.100"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(InfoBoxContainer2, {
          title: t('sellPage:cta.title'),
          boldTitle: t('sellPage:cta.boldTitle'),
          description: t('sellPage:cta.description'),
          boldDescription: t('sellPage:cta.boldDescription'),
          action: t('sellPage:cta.action'),
          actionTitle: t('sellPage:cta.actionTitle'),
          href: "/offerte-auto"
        })]
      })
    }), contentText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
      bgColor: "baseWhite",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
        maxW: isCity ? `8xl` : null,
        mx: "auto",
        color: "baseNeutral.700",
        fontFamily: "Montserrat-Medium",
        fontSize: "md",
        textAlign: "left",
        py: "xxl",
        px: "l",
        className: "landing-text",
        dangerouslySetInnerHTML: {
          __html: contentText
        }
      })
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (NltLandingPage);

/***/ }),

/***/ 26718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18132);
/* harmony import */ var src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34755);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const Head = _ref => {
  let {
    title
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("title", {
      children: [title || t('common:header.title'), ' ', "| CarPlanner"]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Regular.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Medium.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-SemiBold.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .image */ .BH
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[0].image */ .qk[0].image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[1].image */ .qk[1].image
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Head);

/***/ }),

/***/ 71033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ LinkRel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const isMetaTag = value => {
  if (!value || typeof value !== 'object') return false;
  const tag = value;
  const hasNameOrProperty = typeof tag.name === 'string' || typeof tag.property === 'string';
  if (!hasNameOrProperty) return false;
  const contentOk = tag.content === undefined || typeof tag.content === 'string';
  const overrideOk = tag.override === undefined || typeof tag.override === 'string';
  return contentOk && overrideOk;
};

const normalizeMeta = meta => {
  if (!meta) return [];

  if (Array.isArray(meta)) {
    return meta.filter(isMetaTag);
  }

  if (isMetaTag(meta)) {
    return [meta];
  }

  if (typeof meta === 'object') {
    return Object.values(meta).filter(isMetaTag);
  }

  return [];
};

const MetaTags = _ref => {
  let {
    meta
  } = _ref;
  const tags = normalizeMeta(meta);
  if (tags.length === 0) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: tags.map((tag, index) => {
      const content = tag.override && tag.override.trim() !== '' ? tag.override : tag.content ?? '';
      const key = tag.name ?? tag.property ?? `meta-${index}`;

      if (tag.name) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          name: tag.name,
          content: content
        }, key);
      }

      if (tag.property) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          property: tag.property,
          content: content
        }, key);
      }

      return null;
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);
const LinkRel = _ref2 => {
  let {
    rel,
    href,
    crossOrigin,
    type,
    as
  } = _ref2;
  let url = '';

  if (rel === 'canonical' && href.indexOf('?') >= 0) {
    // rimuove eventuali parametri querystring
    url = href.split('?')[0] ?? '';
  } else {
    url = href;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: rel,
      href: url,
      crossOrigin: crossOrigin || null,
      type: type || null,
      as: as || null
    })
  });
};

/***/ }),

/***/ 73119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getFormattedMonthYear; },
/* harmony export */   "h": function() { return /* binding */ replaceDatePlaceholders; }
/* harmony export */ });
const currentDate = new Date();
const monthYear = currentDate.toLocaleString('it-IT', {
  month: 'long',
  year: 'numeric'
});
const formattedMonth = monthYear.charAt(0).toUpperCase() + monthYear.slice(1, -5);
const formattedYear = currentDate.getFullYear();
const getFormattedMonthYear = () => {
  return {
    formattedMonth,
    formattedYear
  };
};
const replaceDatePlaceholders = text => {
  if (!text) return null; // Fallback se il testo è null o undefined

  return text.replace('{{month}}', formattedMonth).replace('{{year}}', String(formattedYear));
};

/***/ }),

/***/ 80028:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noleggio-a-lungo-termine/[landing]",
      function () {
        return __webpack_require__(98523);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82606:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"name":"Bari","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/bari"},{"name":"Bergamo","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/bergamo"},{"name":"Bologna","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/bologna"},{"name":"Brescia","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/brescia"},{"name":"Catania","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/catania"},{"name":"Firenze","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/firenze"},{"name":"Genova","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/genova"},{"name":"Lecce","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/lecce"},{"name":"Lucca","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/lucca"},{"name":"Milano","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/milano"},{"name":"Modena","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/modena"},{"name":"Monza Brianza","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/monza-brianza"},{"name":"Napoli","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/napoli"},{"name":"Padova","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/padova"},{"name":"Palermo","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/palermo"},{"name":"Parma","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/parma"},{"name":"Prato","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/prato"},{"name":"Roma","image":"/images/colosseo-roma.png","href":"/noleggio-a-lungo-termine/roma"},{"name":"Torino","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/torino"},{"name":"Treviso","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/treviso"},{"name":"Udine","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/udine"},{"name":"Venezia","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/venezia"},{"name":"Verona","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/verona"},{"name":"Vicenza","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/vicenza"}]');

/***/ }),

/***/ 34755:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TN":"Lasciati guidare verso\\nla scelta dell’auto migliore","BH":"https://static1.carplanner.com/website/assets/index-head.jpg","Oc":"CarPlanner ti propone le offerte di auto nuove più competitive\\nsul mercato sia per l’acquisto che per il Noleggio a Lungo Termine","qk":[{"image":"https://static1.carplanner.com/website/assets/noleggia-la-tua-auto-a-lungo-termine-2.png","title":"Noleggia la tua auto a lungo termine","description":"Cerchi un’alternativa all’acquisto di un’auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/noleggio-a-lungo-termine","alt":"Offerte noleggio a lungo termine","target":"_self"},{"image":"https://static1.carplanner.com/website/assets/acquista-la-tua-nuova-auto-online-2.png","title":"Acquista la tua nuova auto online","description":"Cerchi la tua\\nnuova auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/offerte-auto","alt":"Offerte auto in vendita","target":"_self"}],"PX":{"a":"Contattaci ora"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(80028); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);